module.exports = (__webpack_require__(8))(89);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/layout/HeaderUserView.js from dll-reference girder_lib
// module id = 970
// module chunks = 0